import React, { Component } from 'react';

class PageSection extends Component {
    render() {
        return (
            <section className={"pp-page-section " + (this.props.className ? this.props.className : '')}>
                { (this.props.sectionTitle || this.props.sectionActions) &&
                    <div className="pp-page-section-header">
                        <h2 className="pp-page-section-title">{ this.props.sectionTitle }</h2>
                        <div className="pp-page-section-actions">
                            { this.props.sectionActions }
                        </div>
                    </div>
                }
                <div className="pp-page-section-content">
                    { this.props.children }
                </div>
            </section>
        );
    }
}

export default PageSection;



// WEBPACK FOOTER //
// ./src/components/PageSection.js